import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { BarcodeLastIndexContext } from '../contexts';
import useBarcode from '../hooks/Barcode/useBarcode';

function BarcodeLastIndexProvider({ children }) {
  const { lastIndex, isLoading, configId } = useBarcode();
  const [barcodeLastIndex, setBarcodeLastIndex] = useState(lastIndex);

  useEffect(() => {
    if (!isLoading && lastIndex) {
      setBarcodeLastIndex(lastIndex);
    }
  }, [isLoading, lastIndex]);
  const obj = useMemo(
    () => ({ barcodeLastIndex, setBarcodeLastIndex, configId }),
    [barcodeLastIndex, configId],
  );

  return (
    <BarcodeLastIndexContext.Provider value={obj}>
      {children}
    </BarcodeLastIndexContext.Provider>
  );
}

BarcodeLastIndexProvider.propTypes = {
  children: PropTypes.object,
};

export default BarcodeLastIndexProvider;
